import { StripeConnectState } from './state';
import { stripeConnectInitialState } from './initial-state';
import { StripeConnectActions } from './action-creators';
import * as actions from './actions';

export const stripeConnectReducer = (
  state: StripeConnectState = stripeConnectInitialState,
  action: StripeConnectActions
): StripeConnectState => {
  switch (action.type) {
    case actions.GET_CONNECTED_ACCOUNT: {
      return {
        ...state,
        account: undefined,
      };
    }

    case actions.GET_CONNECTED_ACCOUNT_SUCCESS: {
      return {
        ...state,
        account: action.account,
      };
    }

    case actions.CREATE_CONNECTED_ACCOUNT_SUCCESS: {
      return {
        ...state,
        account: action.account,
        redirecting: true,
      };
    }

    case actions.CREATE_ONBOARDING_LINK: {
      return {
        ...state,
        redirecting: true,
      };
    }

    case actions.CREATE_ONBOARDING_LINK_ERROR: {
      return {
        ...state,
        redirecting: false,
      };
    }

    case actions.CREATE_TRANSFER_SUCCESS: {
      return {
        ...state,
        lastTx: Number(new Date()),
      };
    }

    default:
      return state;
  }
};
